import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import React from "react";

import { AttachmentsPreview } from "../../attachments/AttachmentsPreview";

const GET_ATTACHMENTS = gql`
  query patientAttachments($uuid: String) {
    patient(uuid: $uuid) {
      uuid
      attachments {
        uuid
        fileName
        fileLink
        createdAt
      }
    }
  }
`;

export default function RecentAttachments({
  isForPatientProfile = true,
  patientUUID,
}) {
  const { data } = useQuery(GET_ATTACHMENTS, {
    variables: { uuid: patientUUID },
    fetchPolicy: "cache-first",
  });

  if (!data) {
    return null;
  }

  return (
    <>
      <AttachmentsPreview
        patientUUID={patientUUID}
        isForPatientProfile={isForPatientProfile}
        isCompactView={true}
        attachments={data?.patient?.attachments}
      />
    </>
  );
}
